/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class SecurityThreatValidationForGCPResponse {
    getFixupPrototypeFunction() { return SecurityThreatValidationForGCPResponse.fixupPrototype; }

    static newInstance(model: Partial<SecurityThreatValidationForGCPResponse>): SecurityThreatValidationForGCPResponse {
        let obj = Object.assign(new SecurityThreatValidationForGCPResponse(), model);
        SecurityThreatValidationForGCPResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<SecurityThreatValidationForGCPResponse>): SecurityThreatValidationForGCPResponse {
        if (!model) return null;
        return SecurityThreatValidationForGCPResponse.newInstance(<SecurityThreatValidationForGCPResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: SecurityThreatValidationForGCPResponse) {
        if (!obj) return;

        models.SecurityThreatValidationForGCPResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: SecurityThreatValidationForGCPResponse): boolean {
        Object.setPrototypeOf(obj, SecurityThreatValidationForGCPResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * If set, Event Threat Detection is enabled.
     */
    event_threat_detection: boolean;

    /**
     * If set, Container Threat Detection is enabled.
     */
    container_threat_detection: boolean;

}
